import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { status } from 'constants/general';
import advertisersStrings from 'modules/advertisers/strings';
import AdvertisersHeader from 'modules/advertisers/components/AdvertisersHeader';
import AdvertisersFilter from 'modules/advertisers/components/AdvertisersFilter';
import AdvertisersList from 'modules/advertisers/components/AdvertisersList';
import Loader from 'modules/common/components/Loader';
import Pagination from 'modules/common/components/Pagination';

import {
  AdvertisersWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  PaginationWrapper,
} from './AdvertisersComponent.style';

const AdvertisersComponent = ({
  searchQuery,
  selectedPageFilter,
  handleAddAdvertiserBtnClick,
  handleEditAdvertiserBtnClick,
  handleAddCampaignBtnClick,
  handleViewCampaignsBtnClick,
  handleSearchBarInputChange,
  handleOrderPaginationClick,
}) => {
  const { advertisersList } = useSelector(state => ({
    advertisersList: state.advertisers.advertisersList,
  }));

  const totalResultsCount = advertisersList?.details?.totalCount;
  const numberOfPages = (totalResultsCount && Math.ceil(totalResultsCount / 10)) || 1;
  const advertisersListArr = advertisersList?.details?.results;

  const renderAdvertisersList = () => {
    if (
      advertisersList.status === status.SHOULD_CALL_API ||
      advertisersList.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (advertisersList.status === status.SUCCESS && advertisersListArr?.length > 0)
      return (
        <>
          <AdvertisersList
            advertisersListArr={advertisersListArr}
            handleEditAdvertiserBtnClick={handleEditAdvertiserBtnClick}
            handleAddCampaignBtnClick={handleAddCampaignBtnClick}
            handleViewCampaignsBtnClick={handleViewCampaignsBtnClick}
          />
          {numberOfPages > 1 && (
            <PaginationWrapper>
              <Pagination
                currentPage={selectedPageFilter}
                totalCount={numberOfPages}
                handleOrderPaginationClick={handleOrderPaginationClick}
              />
            </PaginationWrapper>
          )}
        </>
      );

    return (
      <NoResultsWrapper>
        <NoResultsText>
          {advertisersStrings.advertisersList.advertisersGridNoResultsFound}
        </NoResultsText>
      </NoResultsWrapper>
    );
  };

  return (
    <>
      <AdvertisersHeader handleAddAdvertiserBtnClick={handleAddAdvertiserBtnClick} />
      <AdvertisersWrapper>
        <AdvertisersFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderAdvertisersList()}
      </AdvertisersWrapper>
    </>
  );
};

AdvertisersComponent.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  handleAddAdvertiserBtnClick: PropTypes.func.isRequired,
  handleEditAdvertiserBtnClick: PropTypes.func.isRequired,
  handleAddCampaignBtnClick: PropTypes.func.isRequired,
  handleViewCampaignsBtnClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleOrderPaginationClick: PropTypes.func.isRequired,
};

export default AdvertisersComponent;
